// extracted by mini-css-extract-plugin
export default {"background":"Logout_background__lCCmM","logo":"Logout_logo__YBaF8","btnStyle":"Logout_btnStyle__FTjUf"};